import { useState, useEffect } from "react";
import { fieldType } from "../../../../types/form";
import { FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { SubResetFilter } from "src/pages/DashboardPage/mytasks/meetingsPage/components/MeetingCard";
import { TGDisclosure } from "../../TGDisclosure";
import { TooltipItem } from "src/utils/Tooltip";
import { InfoIcon } from "src/components/ui-icons/myTasks/info";

type Props = {
    dataField: fieldType;
    onChange: (data: any) => void;
    errors?: any;
    value: string;
}

function Radio(props: Props) {
    const { dataField, onChange, errors, value } = props;

    return (
        <>
            {dataField.isFilter &&
                <TGDisclosure disabled={dataField.disabled} wrapperClassName={dataField.width} noticeIcon={dataField.noticeIcon && <TooltipItem wrapperClassName="flex" position="filter" className="left-[-240px]" tooltipsComponent={dataField.notice} tooltipsText="">
                    <>&nbsp;&nbsp;<InfoIcon /></>
                </TooltipItem>} title={dataField.title} count={value && 1 || 0}>
                    <div className="mt-2">
                        {dataField.optionsInputs && dataField.optionsInputs.length > 0 && dataField.optionsInputs.map((option, idx) => (
                            <label key={idx} className={twMerge(
                                "flex text-black cursor-pointer select-none mb-2 w-full",
                                dataField.disabled ? "cursor-not-allowed" : ""
                            )}>
                                <div className="relative">
                                    <input
                                        value={option}

                                        disabled={dataField.disabled}
                                        type="radio"
                                        checked={value === option}
                                        onChange={(e) => {
                                            onChange(e.target.checked ? e.target.value : null);
                                        }}
                                        className="sr-only"
                                    />
                                    <div
                                        className={twMerge(
                                            "flex items-center justify-center w-5 h-5 mr-4 border rounded-full box border-stroke",
                                            dataField.disabled ? "border-gray3 bg-[#DFE4EA]" : "",
                                            value === option ? "border-[#012169]" : ""
                                        )}
                                    >
                                        <span
                                            className={twMerge("h-[10px] w-[10px] rounded-full", value === option ? "bg-darkblue" : "bg-transparent")}
                                        ></span>
                                    </div>
                                </div>
                                <div className="flex flex-row items-center justify-between w-full">
                                    <span>{option}</span>
                                    <span>{dataField.noticeAnswers && dataField.noticeAnswers[idx] && <TooltipItem wrapperClassName="flex" className='left-[-268px]' position="filter" tooltipsComponent={dataField.noticeAnswers[idx]} tooltipsText="">
                                        <>&nbsp;&nbsp;<InfoIcon /></>
                                    </TooltipItem>}</span>
                                </div>
                            </label>
                        ))}
                    </div>
                    <SubResetFilter resetFilter={() => (dataField.key === 'IncidentOption' && onChange('Несоответствие')) || (dataField.key === 'TypeIncident' && onChange('Безопасность')) || (dataField.key === 'Status' && onChange('Активный')) || onChange(null)} />
                </TGDisclosure> ||
                <div className={`${dataField.width} mb-5`}>
                    <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                        <span className="flex flex-row items-center">{dataField.title} {dataField.noticeIcon && <TooltipItem wrapperClassName="flex w-fit sm:w-[758px]" position="top-right" tooltipsComponent={dataField.notice} tooltipsText="">
                            <>&nbsp;&nbsp;<InfoIcon /></>
                        </TooltipItem>}</span>
                        {dataField.require && (
                            <div className="flex flex-row justify-between">
                                {Object.keys(errors).length > 0 && errors[dataField.key] && (
                                    <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
                                )}
                                <span className="text-[#BA0C2F]">*</span>
                            </div>
                        )}
                    </label>
                    <div className="mt-2">
                        {dataField.optionsInputs && dataField.optionsInputs.length > 0 && dataField.optionsInputs.map((option, idx) => (
                            <label key={idx} className={twMerge(
                                "flex text-black cursor-pointer select-none mb-2 w-fit",
                                dataField.disabled ? "cursor-not-allowed" : ""
                            )}>
                                <div className="relative">
                                    <input
                                        value={option}

                                        disabled={dataField.disabled}
                                        type="radio"
                                        checked={value === option}
                                        onChange={(e) => {
                                            onChange(e.target.checked ? e.target.value : null);
                                        }}
                                        className="sr-only"
                                    />
                                    <div
                                        className={twMerge(
                                            "flex items-center justify-center w-5 h-5 mr-4 border rounded-full box border-stroke",
                                            dataField.disabled ? "border-gray3 bg-[#DFE4EA]" : "",
                                            value === option ? "border-[#012169]" : ""
                                        )}
                                    >
                                        <span
                                            className={twMerge("h-[10px] w-[10px] rounded-full", value === option ? "bg-darkblue" : "bg-transparent")}
                                        ></span>
                                    </div>
                                </div>
                                <span className="flex flex-row items-center">{option} {dataField.noticeAnswers && dataField.noticeAnswers[idx] && <TooltipItem wrapperClassName="flex w-fit sm:w-[758px]" position="top-right" tooltipsComponent={dataField.noticeAnswers[idx]} tooltipsText="">
                                    <>&nbsp;&nbsp;<InfoIcon /></>
                                </TooltipItem>}</span>
                            </label>
                        ))}
                    </div>
                </div>
            }
        </>

    );
}

export default Radio;





